import { MfPath } from "../MFormTypes";
import { MfNode } from "../node";

/* eslint no-restricted-syntax: "off" */
/* eslint no-await-in-loop: "off" */

/**
 * Построить список владельцев узла, указанного через dataPath
 * Предполагается, что srcNode либо сам является dataPath, либо содержит его на любом уровне вложенности.
 * @param srcNode
 * @param dataPath
 * @returns
 */
export const buildOwners = (
  srcNode: MfNode,
  dataPath: MfPath,
): MfNode[] | undefined => {
  const { dataKey, items = [] } = srcNode;
  let subPath = dataPath;
  if (dataKey) {
    if (dataPath[0] !== dataKey) {
      return undefined;
    }
    if (dataPath.length === 1) {
      return [srcNode];
    }
    subPath = dataPath.slice(1);
  }
  for (const it of items) {
    const result = buildOwners(it, subPath);
    if (result) {
      return [srcNode, ...result];
    }
  }
  return undefined;
};
